module.exports = __webpack_public_path__ + "static/media/Sonny.5ca99c94.jpeg";